<div class="max-w-full p-6 gap-6 flex flex-col" data-testid="manual-patient-dialog">
  <div class="flex flex-col gap-2">
    <div class="grid grid-cols-[1fr_auto_1fr] items-center w-full">
      <div></div>
      <mat-icon svgIcon="multi-bubble" class="icon-size [--icon-size:32px] [--icon-stroke-width:1] !text-primary"></mat-icon>
      <button type="button" mat-icon-button class="justify-self-end"
        (click)="close()" [attr.aria-label]="'Close' | translate"
        data-testid="manual-patient-close-button">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <h2 class="headline-small text-on-surface text-center w-full" data-testid="manual-patient-title">{{ data.from === 'edit' ? ('Edit patient' | translate) : ('Add patient manually' | translate) }}</h2>
  </div>

  <div class="w-full flex flex-col items-center gap-4">
    <div class="w-full flex flex-col gap-4">
      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'Patient name' | translate }}</mat-label>
        <input matInput [(ngModel)]="patientName" type="text" data-testid="manual-patient-name-input" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="w-full" subscriptSizing="dynamic">
        <mat-label>{{ 'Patient ID' | translate }}</mat-label>
        <input matInput [(ngModel)]="patientId" type="text" data-testid="manual-patient-id-input" />
      </mat-form-field>

      <app-dmy-date-field
        *ngIf="!isLegalOrg"
        [value]="dateOfBirth"
        (valueChange)="dateOfBirth = $event"
        mode="birth"
        [allowEmpty]="true"
        [label]="'Date of birth' | translate"
        testId="manual-patient-dob-input"
      />
    </div>
  </div>

  <div class="flex flex-col gap-2">
    <button mat-flat-button color="primary" class="w-full rounded-[8px] h-12" (click)="confirm()" [disabled]="isConfirming" data-testid="manual-patient-confirm-button">{{ buttonLabel | translate }}</button>
    <button mat-button class="title-medium text-primary w-full" (click)="goBack()" data-testid="manual-patient-back-button">
      <mat-icon>chevron_left</mat-icon>
      {{ 'Back' | translate }}
    </button>
  </div>
</div>

